import {isPlainObject, isArray, each} from "lodash"

export default function stripEtag(data: any) {
  if (isArray(data)) {
    each(data, (item) => stripEtag(item))
  } else if (isPlainObject(data)) {
    data.etag = undefined // inconsitency in BE services
    data.Etag = undefined
    each(data, (item) => {
      if (shouldIterate(item)) stripEtag(item)
    })
  }
}

function shouldIterate(obj: any) {
  return isPlainObject(obj) || Array.isArray(obj)
}
